import { render, staticRenderFns } from "./greetings.vue?vue&type=template&id=7a99a9ff&scoped=true"
import script from "./greetings.vue?vue&type=script&lang=js"
export * from "./greetings.vue?vue&type=script&lang=js"
import style0 from "./greetings.vue?vue&type=style&index=0&id=7a99a9ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a99a9ff",
  null
  
)

export default component.exports